
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

// WhatsApp Floating Button Component
const WhatsAppButton = () => {
  return (
    <>
      <style>
        {`
          @keyframes gentle-pulse {
            0%, 100% {
              box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
            }
            50% {
              box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
            }
          }
          .whatsapp-gentle-pulse {
            animation: gentle-pulse 3s infinite;
          }
        `}
      </style>
      <div className="fixed bottom-6 right-6 z-50">
        {/* Clean WhatsApp button */}
        <a
          href="https://api.whatsapp.com/send?phone=5511998961030&text=Olá! Gostaria de agendar uma consulta odontológica."
          target="_blank"
          rel="noopener noreferrer"
          className="group bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 whatsapp-gentle-pulse"
        >
          <i className="ri-whatsapp-fill text-2xl group-hover:scale-110 transition-transform duration-300"></i>
          
          {/* Clean tooltip */}
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-lg">
            Fale conosco
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
          </div>
        </a>
      </div>
    </>
  )
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppButton />
    </BrowserRouter>
  )
}

export default App
